type PendleSwapResponse = {
  transaction: {
    data: `0x${string}`;
    to: `0x${string}`;
  };
  data: {
    priceImpact: number;
    amountPtOut: string;
  };
};

export const isPendleSwapResponse = (obj: any): obj is PendleSwapResponse => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "transaction" in obj &&
    typeof obj.transaction === "object" &&
    obj.transaction !== null &&
    "data" in obj.transaction &&
    typeof obj.transaction.data === "string" &&
    obj.transaction.data.startsWith("0x") &&
    "to" in obj.transaction &&
    typeof obj.transaction.to === "string" &&
    obj.transaction.to.startsWith("0x") &&
    "data" in obj &&
    typeof obj.data === "object" &&
    obj.data !== null &&
    "priceImpact" in obj.data &&
    typeof obj.data.priceImpact === "number" &&
    "amountPtOut" in obj.data &&
    typeof obj.data.amountPtOut === "string"
  );
};
